// The kind (category) of a task (B32, B52): none, Klusjes or one of PK's own.
import { useCategories } from "../lib/categories";
import { cn } from "./ui";

export function CategoryChoice({ value, onChange }: { value: string | null; onChange: (id: string | null) => void }) {
  const categories = useCategories();
  if (!categories) return null;
  return (
    <fieldset>
      <legend className="mb-2 font-semibold">Categorie</legend>
      <div role="radiogroup" aria-label="Categorie" className="flex flex-wrap gap-2">
        {[{ id: null as string | null, name: "Geen" }, ...categories].map((c) => (
          <button
            key={c.id ?? "geen"}
            type="button"
            role="radio"
            aria-checked={value === c.id}
            onClick={() => onChange(c.id)}
            className={cn(
              "min-h-11 rounded-xl border-2 px-3 [overflow-wrap:anywhere]",
              value === c.id ? "border-pine bg-pine text-paper" : "border-mist bg-paper text-ink",
            )}
          >
            {c.name}
          </button>
        ))}
      </div>
    </fieldset>
  );
}

/** Filter chips above a list: Alles or one category. */
export function CategoryFilter({ value, onChange }: { value: string | null; onChange: (id: string | null) => void }) {
  const categories = useCategories();
  if (!categories?.length) return null;
  return (
    <div role="radiogroup" aria-label="Filter op categorie" className="mb-4 flex flex-wrap gap-2">
      {[{ id: null as string | null, name: "Alles" }, ...categories].map((c) => (
        <button
          key={c.id ?? "alles"}
          type="button"
          role="radio"
          aria-checked={value === c.id}
          onClick={() => onChange(c.id)}
          className={cn(
            "min-h-11 rounded-xl border-2 px-3 text-sm [overflow-wrap:anywhere]",
            value === c.id ? "border-pine bg-pine text-paper" : "border-mist bg-surface text-ink",
          )}
        >
          {c.name}
        </button>
      ))}
    </div>
  );
}
